import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { formatDate } from '../lib/dateUtils';
import { enumChip } from '../lib/enumLabels';

const OutwardLettersPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? 'ar' : 'en';

  const columns: GridColDef[] = [
    { field: 'internal_id', headerName: t('outwardLetters.internalId'), width: 120 },
    { field: 'title', headerName: t('outwardLetters.letterTitle'), flex: 1, minWidth: 250 },
    {
      field: 'delivery_method',
      headerName: t('outwardLetters.deliveryMethod'),
      width: 150,
      renderCell: (params) => {
        const chip = enumChip('delivery_method', params.value, locale);
        return chip ? <Chip label={chip.label} color={chip.color} size="small" /> : null;
      },
    },
    {
      field: 'date', 
      headerName: t('outwardLetters.date'), 
      width: 150,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
  ];

  const fields = [
    { 
      name: 'internal_id', 
      label: t('outwardLetters.internalId'), 
      type: 'text' as const 
    },
    { 
      name: 'title', 
      label: t('outwardLetters.letterTitle'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'body',
      label: t('outwardLetters.body'),
      type: 'richtext' as const,
      width: 'full' as const,
      required: true
    },
    { 
      name: 'to_recipient', 
      label: t('outwardLetters.recipient'), 
      type: 'select' as const,
      foreignKey: {
        table: 'profiles',
        valueField: 'id',
        labelField: 'email'
      }
    },
    { 
      name: 'delivery_method', 
      label: t('outwardLetters.deliveryMethod'), 
      type: 'select' as const,
      options: [
        { value: 'email', label: t('outwardLetters.email') },
        { value: 'fax', label: t('outwardLetters.fax') },
        { value: 'hand_delivery', label: t('outwardLetters.handDelivery') },
        { value: 'post', label: t('outwardLetters.post') }
      ]
    },
    { 
      name: 'date', 
      label: t('outwardLetters.date'), 
      type: 'date' as const 
    },
  ];

  return (
    <GenericTablePage 
      tableName="outward_letters"
      title={t('outwardLetters.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default OutwardLettersPage;
